/**
 * Cacah berikut satuannya, dalam bentuk yang benar untuk cacah itu.
 *
 * Lahir dari satu layar yang mencetak tujuh kalimat sekaligus: "Display 1
 * wells", "1 wells · DTC", "4 model", "Estimate 1 wells". Tidak satu pun
 * melempar, tidak satu pun tertangkap `tsc`, dan tidak satu pun terlihat
 * sampai cacahnya kebetulan satu — yaitu keadaan yang paling sering ditemui
 * orang, sebab sumur yang kurvanya hilang biasanya memang satu.
 *
 * Ditulis sebagai fungsi dan bukan sebagai tujuh operator bersyarat yang
 * disalin: yang disalin tujuh kali adalah yang salah di tempat kedelapan.
 *
 * Angkanya diberi pemisah ribuan dengan tera yang sama dengan seluruh layar
 * lain — 1.402 sumur Teapot Dome tercetak "1,402 wells" dan bukan "1402".
 *
 * Hanya untuk kata benda. Kesesuaian **kata kerja** berjalan ke arah
 * sebaliknya — "1 needs", "2 need" — dan sebuah fungsi yang melayani keduanya
 * akan dipanggil dengan arah yang keliru cepat atau lambat.
 */
export function count(n: number, singular: string, plural = `${singular}s`): string {
  return `${n.toLocaleString("en-US")} ${n === 1 ? singular : plural}`;
}
